//angular modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientModule, HttpClient } from '@angular/common/http';

//vendor modules
import { NgxsModule } from '@ngxs/store';
import { StorageServiceModule } from 'angular-webstorage-service';



//app modules
import { MainModule } from './main/main.module';
import { SharedModule } from './shared/shared.module';
import { DeviceDetectorModule } from 'ngx-device-detector';

//app services
import { AuthGuardService, PollDataService, TrackingService } from './shared/services/index'

//app states
import { MainStates } from './main/store';

//app components
import { LayoutComponent } from './main/components/layout/layout.component';
import { PollLauncherComponent } from './polls/components/index';
import { PageNotFoundComponent } from './not-found.component';
import { environment } from '@environments/environment';
import { EulaComponent } from './eula/eula.component';

import { EsLoginModule } from '@examsoft/es-login';

import { TranslationModule } from '@examsoft/translation';

@NgModule({
  declarations: [
    PageNotFoundComponent,
    PollLauncherComponent,
    EulaComponent
  ],
  imports: [
		DeviceDetectorModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    NgxsModule.forRoot(MainStates, {
      developmentMode: !environment.production
    }),
    FormsModule,
    ReactiveFormsModule,
    MainModule.forRoot(),
    HttpClientModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    EsLoginModule.forRoot(environment),
    StorageServiceModule,
    TranslationModule.forRoot({
      defaultLanguage: 'en',
      languages: {
        ar: { isRTL: true },
        es: { isRTL: false }
      }
    }),
  ],
  providers: [
    AuthGuardService,
    PollDataService,
    TrackingService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [LayoutComponent]
})
export class AppModule {}
